var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 68,
    viewBox: "0 0 80 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_62_229)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.350846 57.3796C12.2805 51.4794 18.2452 44.5467 18.2452 36.5813C13.1605 35.9913 8.95581 33.9017 5.63115 30.3124C2.3065 26.723 0.644199 22.5684 0.644199 17.8482C0.644199 12.8329 2.25761 8.6045 5.48448 5.16269C8.71136 1.72088 12.7693 4.76837e-07 17.6585 4.76837e-07C23.1344 4.76837e-07 27.8769 2.23714 31.886 6.7115C35.8952 11.1859 37.8997 16.6189 37.8997 23.0108C37.8997 42.1866 27.2414 57.1829 5.92451 68L0.350846 57.3796ZM42.4511 57.3796C54.4786 51.4794 60.4922 44.5467 60.4922 36.5813C55.3096 35.9913 51.0561 33.9017 47.7314 30.3124C44.4068 26.723 42.7445 22.5684 42.7445 17.8482C42.7445 12.8329 44.3823 8.6045 47.6581 5.16269C50.9339 1.72088 55.0163 4.76837e-07 59.9055 4.76837e-07C65.3814 4.76837e-07 70.0994 2.23714 74.0596 6.7115C78.0199 11.1859 80 16.6189 80 23.0108C80 42.1866 69.3906 57.1829 48.1715 68L42.4511 57.3796Z",
    fill: "#3838C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 68,
    fill: "white",
    transform: "translate(80 68) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMark);
export default __webpack_public_path__ + "static/media/Quote Mark.d103d02a7b1ce52521a7992213ce3f1a.svg";
export { ForwardRef as ReactComponent };